var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/games/icon-sport") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,3 C22.4032609,3 28,8.59673913 28,15.5 C28,22.4032609 22.4032609,28 15.5,28 C8.59565217,28 3,22.4032609 3,15.5 C3,8.59673913 8.59565217,3 15.5,3 Z M13.723913,5.28586957 C13.1423913,5.38695652 12.5695652,5.53804348 12.0076087,5.73804348 C10.701087,6.20543478 9.5173913,6.92065217 8.48586957,7.86847826 C8.11413043,8.21086957 7.77065217,8.57717391 7.45543478,8.96304348 C7.45543478,8.96304348 7.18586957,9.24782609 6.87065217,9.81847826 C5.78478261,11.4543478 5.15217391,13.4163043 5.15217391,15.5271739 C5.15217391,15.8478261 5.16847826,16.1641304 5.19673913,16.4782609 C5.19456522,16.5054348 5.19021739,16.5304348 5.18695652,16.5576087 C5.27065217,17.3869565 5.45543478,18.2021739 5.73804348,18.9934783 C5.89347826,19.4282609 6.07608696,19.848913 6.28586957,20.2554348 C6.29021739,20.2576087 6.29456522,20.2586957 6.29891304,20.2608696 C8.0173913,23.5945652 11.4913043,25.875 15.5,25.875 C19.4054348,25.875 22.8054348,23.7097826 24.5673913,20.5141304 L24.4391304,20.6880435 C25.3152174,19.3217391 25.5065217,18.1728261 25.5065217,18.1728261 C25.7,17.4456522 25.8228261,16.7 25.8554348,15.9380435 C25.8706522,15.5663043 25.8673913,15.1967391 25.8434783,14.8293478 C25.7086957,14.9641304 25.2956522,15.4032609 25,15.6978261 L21.4402174,13.9184783 L20.1641304,10.25 L21.601087,8.17173913 C22.4891304,8.54130435 23.7206522,9.44782609 24.2684783,9.97173913 C23.9369565,9.44673913 23.5576087,8.95217391 23.1304348,8.48804348 C22.1847826,7.45869565 21.0630435,6.64347826 19.801087,6.0673913 C19.126087,5.75978261 18.426087,5.52826087 17.7086957,5.37173913 C18.5141304,5.6673913 19.1836957,6.27282609 19.8608696,6.80326087 C19.8978261,6.83369565 20.2173913,7.13369565 20.4456522,7.35978261 L18.9836957,9.47391304 L15.6565217,9.4 L12.748913,6.4923913 C13.0815217,6.08369565 13.4423913,5.60217391 13.723913,5.28586957 Z M14.0883696,14.7431522 L16.8633696,16.8007609 L16.7090217,22.6007609 C15.4611957,23.3355435 14.001413,23.5355435 13.7079348,23.5670652 C10.1133696,22.2725 8.57641304,20.0670652 8.55793478,20.0398913 L8.52315217,20.0638043 L8.6601087,16.8496739 L14.0883696,14.7431522 Z M20.7320652,15.1440217 L24.4190227,16.9875 C24.4190227,16.9875 24.4375,20.3016304 20.8461957,22.7429348 C20.4146739,22.9625 20.0157609,23.1157609 19.6820652,23.2179348 C19.086413,23.0820652 18.5418478,22.8505435 18.1201087,22.638587 L18.2701087,17.0190217 L20.7320652,15.1440217 Z M11.6101087,7.35217391 L14.5590217,10.301087 L13.5622826,13.4315217 L8.17858696,15.5206522 L6.9698913,14.026087 C7.1351087,9.33478261 10.7590217,7.60326087 11.6101087,7.35217391 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.0%",
    y: "-8.0%",
    width: "132.0%",
    height: "132.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/games/icon-sport",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSport);
export default __webpack_public_path__ + "static/media/icon-sport.9058eeaa4f94709fa7321e947465117d.svg";
export { ForwardRef as ReactComponent };